import axios from 'axios';

const cancelMultipleAppointments = async (
  listingId: string,
  appointmentsToCancel: Record<string, boolean>,
  cancelReason?: string,
) => {
  await axios.post(`/appointments/cancelMultipleAppointments`, {
    appointmentsToCancel,
    listingId,
    cancelReason,
  });
};

export default cancelMultipleAppointments;
